import { httpsCallable } from "firebase/functions";
import { functions, FunctionResponse } from "./app";
import { Profile } from "../firestore/profile";

const remoteUpdateProfile = httpsCallable(functions, "updateProfile");

export async function updateProfile(
  profile: Profile,
): Promise<FunctionResponse> {
  const result = await remoteUpdateProfile({ ...profile });

  return result.data as FunctionResponse;
}
